import { T_DataTableColumn } from 'types/data-table';

import { RedeliveryNumber } from 'components/tables/utils';
import RedeliveryTableRow from './redelivery-table-row';

export class RedeliveryColumns {
  customerId: T_DataTableColumn<RedeliveryTableRow, 'number'> = {
    width: 80,
    field: 'customerId',
    label: 'ACC ID',
    type: 'number',
    category: 'common',
    skipQuickSearch: true
  };
  customerCode: T_DataTableColumn<RedeliveryTableRow, 'text'> = {
    width: 80,
    field: 'customerCode',
    label: 'ACC CODE',
    type: 'text',
    category: 'common'
  };
  customerFullName: T_DataTableColumn<RedeliveryTableRow, 'text'> = {
    width: 160,
    field: 'customerFullName',
    label: 'ACC FULL NAME',
    type: 'text',
    category: 'common',
    skipQuickSearch: true
  };
  customerName: T_DataTableColumn<RedeliveryTableRow, 'text'> = {
    width: 160,
    field: 'customerName',
    label: 'ACC NAME',
    type: 'text',
    category: 'common'
  };
  id: T_DataTableColumn<RedeliveryTableRow, 'number'> = {
    width: 80,
    field: 'id',
    label: 'RECORD',
    type: 'number',
    category: 'common',
    skipQuickSearch: true
  };
  expirationDate: T_DataTableColumn<RedeliveryTableRow, 'dateTime'> = {
    width: 120,
    field: 'expirationDate',
    label: 'EXPIRATION',
    type: 'dateTime',
    category: 'common',
    dateFormat: 'l',
    skipQuickSearch: true
  };
  locationId: T_DataTableColumn<RedeliveryTableRow, 'number'> = {
    width: 80,
    field: 'locationId',
    label: 'LOC ID',
    type: 'number',
    category: 'common',
    skipQuickSearch: true
  };
  locationCode: T_DataTableColumn<RedeliveryTableRow, 'text'> = {
    width: 80,
    field: 'locationCode',
    label: 'LOC CODE',
    type: 'text',
    category: 'common'
  };
  locationName: T_DataTableColumn<RedeliveryTableRow, 'text'> = {
    width: 160,
    field: 'locationName',
    label: 'LOC NAME',
    type: 'text',
    category: 'common'
  };
  notes: T_DataTableColumn<RedeliveryTableRow, 'text'> = {
    width: 160,
    field: 'customerName',
    label: 'ACC NAME',
    type: 'text',
    category: 'common'
  };
  redeliveryDetails: T_DataTableColumn<RedeliveryTableRow, 'text'> = {
    width: 160,
    field: 'redeliveryDetails',
    label: 'DETAILS',
    type: 'text',
    category: 'common'
  };
  count: T_DataTableColumn<RedeliveryTableRow, 'number'> = {
    width: 80,
    field: 'count',
    label: 'QUANTITY',
    type: 'number',
    category: 'common',
    sortable: false,
    skipQuickSearch: true
  };
  received: T_DataTableColumn<RedeliveryTableRow, 'number'> = {
    width: 80,
    field: 'received',
    label: 'RECEIVED',
    type: 'number',
    category: 'common',
    sortable: false,
    skipQuickSearch: true
  };
  sizeType: T_DataTableColumn<RedeliveryTableRow, 'text'> = {
    width: 120,
    field: 'sizeType',
    label: 'SIZETYPE',
    type: 'text',
    category: 'common'
  };
  redeliveryNumber: T_DataTableColumn<RedeliveryTableRow, 'text'> = {
    width: 120,
    field: 'redeliveryNumber',
    label: 'REDELIVERY',
    type: 'text',
    category: 'common',
    renderCell: (_, row) => <RedeliveryNumber redelivery={row} ADMIN BILLING_ADMIN SENIOR_BOOKING BOOKING CUSTOMER />
  };
  startDate: T_DataTableColumn<RedeliveryTableRow, 'dateTime'> = {
    width: 120,
    field: 'expirationDate',
    label: 'START DATE',
    type: 'dateTime',
    category: 'common',
    dateFormat: 'l',
    skipQuickSearch: true
  };
  anyTruckingCompany: T_DataTableColumn<RedeliveryTableRow, 'boolean'> = {
    width: 80,
    field: 'anyTruckingCompany',
    label: 'ANY CARRIER',
    type: 'boolean',
    category: 'common',
    sortable: false,
    skipQuickSearch: true
  };
  unitCount: T_DataTableColumn<RedeliveryTableRow, 'number'> = {
    width: 80,
    field: 'unitCount',
    label: 'UNITS',
    type: 'number',
    category: 'common',
    sortable: false,
    skipQuickSearch: true
  };
}

export default RedeliveryColumns;
